// Dummy users for frontend authentication
export const DUMMY_USERS = [
  {
    email: "shashank@kendal.ai",
    password: "shashank123",
    name: "Shashank Jangra",
    uid: "dummy-uid-1",
    phoneNumber: "+971500000001",
  },
  {
    email: "dd@ddre.global",
    password: "daniel123",
    name: "Daniel Daggers",
    uid: "dummy-uid-2",
    phoneNumber: "+971500000002",
  },
  {
    email: "joel@kendal.ai",
    password: "joel123",
    name: "Joel Alexander",
    uid: "dummy-uid-3",
    phoneNumber: "+971500000003",
  },
  {
    email: "aman@kendal.ai",
    password: "aman123",
    name: "Aman Thakker",
    uid: "dummy-uid-4",
    phoneNumber: "+971500000004",
  },
  {
    email: "Melanie.Brown@ddre.global",
    password: "melanie123",
    name: "Melanie Brown",
    uid: "dummy-uid-5",
    phoneNumber: "+971500000005",
  },
];

export const DUMMY_PHONE_USERS = [
  {
    phoneNumber: "+971500000001",
    otp: "123456",
    name: "Shashank Jangra",
    uid: "dummy-uid-1",
  },
  {
    phoneNumber: "+971500000002",
    otp: "654321",
    name: "Daniel Daggers",
    uid: "dummy-uid-2",
  },
  {
    phoneNumber: "+971500000003",
    otp: "111111",
    name: "Joel Alexander",
    uid: "dummy-uid-3",
  },
  {
    phoneNumber: "+971500000004",
    otp: "222222",
    name: "Aman Thakker",
    uid: "dummy-uid-4",
  },
  {
    phoneNumber: "+971500000005",
    otp: "333333",
    name: "Melanie Brown",
    uid: "dummy-uid-5",
  },
];
